import { render, staticRenderFns } from "./CheckboxMatrizField.vue?vue&type=template&id=3e83a8ee&scoped=true&"
import script from "./CheckboxMatrizField.vue?vue&type=script&lang=js&"
export * from "./CheckboxMatrizField.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxMatrizField.vue?vue&type=style&index=0&id=3e83a8ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e83a8ee",
  null
  
)

export default component.exports